"use client";

import { Fragment } from "react";

const MOCKS = {
  m0: {
    title: { en: "Today's plan", sl: "Današnji načrt" },
    cap1: { en: "MON · JUNE 8", sl: "PON · 8. JUN" },
    cap2: { en: "AI SUGGESTED", sl: "AI PREDLOG" },
    hint: {
      en: "Proposed from your goals, tasks app & calendars — confirm or add your own.",
      sl: "Predlagano iz tvojih ciljev, opravil in koledarjev — potrdi ali dodaj svoje.",
    },
    rows: [
      {
        nm: { en: "Draft the monthly strategy", sl: "Osnutek mesečne strategije" },
        tm: "09:00",
        src: "goal",
        srcL: { en: "Goal", sl: "Cilj" },
        done: 1,
      },
      {
        nm: { en: "Deep focus: launch prep", sl: "Globok fokus: priprava na lansiranje" },
        tm: "10:30",
        src: "task",
        srcL: { en: "Tasks", sl: "Opravila" },
        done: 1,
      },
      {
        nm: { en: "Sync with the team", sl: "Uskladitev z ekipo" },
        tm: "14:00",
        src: "cal",
        srcL: { en: "Calendar", sl: "Koledar" },
        done: 1,
      },
      {
        nm: { en: "Run along the river", sl: "Tek ob reki" },
        tm: "18:00",
        src: "goal",
        srcL: { en: "Goal", sl: "Cilj" },
        done: 0,
      },
    ],
    add: { en: "Add your own", sl: "Dodaj svoje" },
  },
  m1: {
    title: { en: "Today's focus", sl: "Današnji fokus" },
    cap1: { en: "MON · 13:42", sl: "PON · 13:42" },
    cap2: { en: "FOCUS · 52 MIN", sl: "FOKUS · 52 MIN" },
    note: {
      en: "First pass done — needs a review tomorrow.",
      sl: "Prvi prehod opravljen — jutri potrebuje pregled.",
    },
    noteLabel: { en: "Note", sl: "Opomba" },
  },
  m2: {
    title: { en: "Today's journal", sl: "Današnji dnevnik" },
    cap1: { en: "MON · END OF DAY", sl: "PON · KONEC DNEVA" },
    cap2: { en: "JOURNAL", sl: "DNEVNIK" },
    lead2: {
      en: "The strategy finally clicked into place.",
      sl: "Strategija je končno padla na svoje mesto.",
    },
    rest: {
      en: " Three deep hours of work, no interruptions. The team sync opened a direction I hadn't seen before.",
      sl: " Tri globoke ure dela, brez prekinitev. Uskladitev z ekipo je odprla smer, ki je prej nisem videl.",
    },
  },
  m3: {
    title: { en: "Tomorrow's preview", sl: "Predogled jutrišnjega dne" },
    cap1: { en: "TOMORROW · TUE", sl: "JUTRI · TOR" },
    cap2: { en: "PREVIEW", sl: "PREDOGLED" },
    nums: [
      { en: "Finish the deck before lunch.", sl: "Dokončaj predstavitev pred kosilom." },
      { en: "One screen-free hour in the evening.", sl: "Ena ura brez zaslonov zvečer." },
    ],
  },
} as const;

export function HiwMock({ i, lang }: { i: number; lang: "en" | "sl" }) {
  const en = lang === "en";

  if (i === 0) {
    const m = MOCKS.m0;
    return (
      <div className="mk">
        <div className="mk-cap">
          <span>{en ? m.cap1.en : m.cap1.sl}</span>
          <span>{en ? m.cap2.en : m.cap2.sl}</span>
        </div>
        <div className="mk-title">{en ? m.title.en : m.title.sl}</div>
        <div className="mk-hint">{en ? m.hint.en : m.hint.sl}</div>
        {m.rows.map((r, idx) => (
          <div className="mk-row" key={idx}>
            <span className={"box" + (r.done ? " done" : "")} />
            <span className="nm">{en ? r.nm.en : r.nm.sl}</span>
            <span className={"src " + r.src}>{en ? r.srcL.en : r.srcL.sl}</span>
            <span className="tm">{r.tm}</span>
          </div>
        ))}
        <div className="mk-add">
          <span className="plus">+</span>
          <span>{en ? m.add.en : m.add.sl}</span>
        </div>
      </div>
    );
  }

  if (i === 1) {
    const m = MOCKS.m1;
    const rows = MOCKS.m0.rows;
    return (
      <div className="mk">
        <div className="mk-cap">
          <span>{en ? m.cap1.en : m.cap1.sl}</span>
          <span>{en ? m.cap2.en : m.cap2.sl}</span>
        </div>
        <div className="mk-title">{en ? m.title.en : m.title.sl}</div>
        {rows.map((r, idx) => {
          const struck = idx === 0 || idx === 1;
          return (
            <Fragment key={idx}>
              <div className="mk-row">
                <span className={"box" + (struck ? " done" : "")} />
                <span className={"nm" + (struck ? " struck" : "")}>
                  {en ? r.nm.en : r.nm.sl}
                </span>
                <span className={"src " + r.src}>{en ? r.srcL.en : r.srcL.sl}</span>
                <span className="tm">{r.tm}</span>
              </div>
              {idx === 1 && (
                <div className="mk-note">
                  <span className="nt">{en ? m.noteLabel.en : m.noteLabel.sl}</span>
                  <span className="nx">{en ? m.note.en : m.note.sl}</span>
                </div>
              )}
            </Fragment>
          );
        })}
      </div>
    );
  }

  if (i === 2) {
    const m = MOCKS.m2;
    return (
      <div className="mk">
        <div className="mk-cap">
          <span>{en ? m.cap1.en : m.cap1.sl}</span>
          <span>{en ? m.cap2.en : m.cap2.sl}</span>
        </div>
        <div className="mk-title">{en ? m.title.en : m.title.sl}</div>
        <p className="mk-prose">
          <span className="lead2">{en ? m.lead2.en : m.lead2.sl}</span>
          {en ? m.rest.en : m.rest.sl}
        </p>
      </div>
    );
  }

  const m = MOCKS.m3;
  return (
    <div className="mk">
      <div className="mk-cap">
        <span>{en ? m.cap1.en : m.cap1.sl}</span>
        <span>{en ? m.cap2.en : m.cap2.sl}</span>
      </div>
      <div className="mk-title">{en ? m.title.en : m.title.sl}</div>
      {m.nums.map((n, z) => (
        <div className="mk-num" key={z}>
          <span className="n">0{z + 1}</span>
          <span>{en ? n.en : n.sl}</span>
        </div>
      ))}
    </div>
  );
}
